angular.module('pitch.playlist', [
    //this uses pitch.app - and pitch.app uses this - is this correct. For now it seems to work?
    //@todo Move some shared functionality in core module.
    'pitch.app',
    'satv.playlist',
    'ui.router'
])

.config(function($stateProvider, config) {

    //template helper
    function tpl(t) {
        return config.templateRoot + '/' + t + '?version=' + config.app_release_id;
    }

    $stateProvider

        .state('myMusic', {
            url: "/my-music",
            templateUrl: tpl('templates/playlists/index'),
            abstract: true
        })

        .state('myMusic.playlists', {
            url: "/playlists/my",
            templateUrl: tpl('templates/playlists/search-my-playlists'),
            controller: 'PitchMyPlaylistsCtrl',
            resolve: {
                playlistLoader: function(PlaylistsLoader) {
                    return new PlaylistsLoader({
                        sortBy: 'modifiedDate',
                        sortOrder: 'DESC',
                        user: true,
                        activity: false
                    }).getFirstPage();
                },
                auditionFormat: function() {
                    return 'mp3';

                },
                context:  function() {
                    return {name: 'my-playlists'};
                }
            }
        })

        .state('myMusic.playlistsSharedWithMe', {
            url: "/playlists/shared",
            templateUrl: tpl('templates/playlists/search-playlists'),
            controller: 'PitchMyPlaylistsCtrl',
            resolve: {
                playlistLoader: function(PlaylistsLoader) {
                    return new PlaylistsLoader({
                        sortBy: 'modifiedDate',
                        sortOrder: 'DESC',
                        sharedWithUser: true,
                        activity: false
                    }).getFirstPage();
                },
                auditionFormat: function() {
                    return 'mp3';
                },
                context:  function() {
                    return {name: 'shared-playlists'};
                }
            }
        })

        .state('myMusic.playlistsPitched', {
            url: "/playlists/pitched",
            templateUrl: tpl('templates/playlists/search-playlists'),
            controller: 'PitchMyPlaylistsCtrl',
            resolve: {
                playlistLoader: function(PlaylistsLoader) {
                    return new PlaylistsLoader({
                        sortBy: 'modifiedDate',
                        sortOrder: 'DESC',
                        isPitch: true,
                        activity: false
                    }).getFirstPage();
                },
                auditionFormat: function() {
                    return 'mp3';
                },
                context:  function() {
                    return {name: 'pitched-playlist'};
                }
            }
        })

        .state('myMusic.playlistsPublic', {
            url: "/playlists/public",
            templateUrl: tpl('templates/playlists/search-playlists'),
            controller: 'PitchMyPlaylistsCtrl',
            resolve: {
                playlistLoader: function(PlaylistsLoader) {
                    return new PlaylistsLoader({
                        sortBy: 'modifiedDate',
                        sortOrder: 'DESC',
                        isPublic: true,
                        activity: false
                    }).getFirstPage();
                },
                auditionFormat: function() {
                    return 'mp3';
                },
                context:  function() {
                    return {name: 'public-playlists'};
                }
            }
        })

        //landing page within the context of my-music
        .state('myMusic.playlistLanding', {
            url: "/playlists/{id:int}",
            templateUrl: tpl('templates/playlists/search-playlists'),
            controller: 'PitchMyPlaylistsCtrl',
            resolve: {
                playlistLoader: function(PlaylistsLoader, $stateParams) {
                    var loader = new PlaylistsLoader({
                        id: $stateParams.id
                    });

                    loader.method = 'get';

                    //we're only getting a single object,.. in order to have the view
                    //render correctly we need to wrap this in an array so that we have
                    //a loader object with a single playlist.
                    loader.parseResponse = function(r) {
                        loader.setData([r]);
                    };

                    return loader.getAll(true);
                },
                auditionFormat: function() {
                    return 'mp3';
                },
                context:  function() {
                    return {name: 'my-playlist'};
                }
            }
        })
        .state('myMusic.playlistsLicensee', {
            url: "/playlists/licensee",
            templateUrl: tpl('templates/playlists/search-playlists'),
            controller: 'PitchMyPlaylistsCtrl',
            resolve: {
                playlistLoader: function(PlaylistsLoader) {
                    return new PlaylistsLoader({
                        sortBy: 'modifiedDate',
                        sortOrder: 'DESC',
                        activity: false,
                        licensee: true,
                     }).getFirstPage();
                },
                auditionFormat: function() {
                    return 'mp3';
                },
                context:  function() {
                    return {name: 'licensee-playlists'};
                }
            }
        })
    ;
})
;


// WEBPACK FOOTER //
// ./src/PlaylistClientBundle/Resources/js/angular/app.js